import React, { useEffect, useState, useRef } from 'react'
import { apiPath1 } from "../services/apiConfig";
import LoadingModal from '../components/Loading'

export default function StoreWiseInventory() {
  const token = localStorage.getItem('token');

  const [invSumByStoreWarehouse, setInvSumByStoreWarehouse] = useState([]);
  const [invSumByStoreSite, setInvSumByStoreSite] = useState([]);
  const [invSumByStoreRepair, setInvSumByStoreRepair] = useState([]);
  const [loading, setLoading] = useState(false);

  const [warehousePresent, setWarehousePresent] = useState(true);
  const [sitePresent, setSitePresent] = useState(true);
  const [repairShopPresent, setRepairShopPresent] = useState(true);

  // 
  // Get Stock Data
  //
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        // Fetch warehouse data
        const response_1 = await fetch(apiPath1 + "InvSumQtyByStore/warehouse", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result_1 = await response_1.json();
        if (result_1.status !== true) {
          setWarehousePresent(false);
          setInvSumByStoreWarehouse(result_1.msg);
        } else {
          setInvSumByStoreWarehouse(result_1.data);
        }


        // Fetch site data
        const response_2 = await fetch(apiPath1 + "InvSumQtyByStore/site", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result_2 = await response_2.json();
        if (result_2.status !== true) {
          setSitePresent(false);
          setInvSumByStoreSite(result_2.msg);
        } else {
          setInvSumByStoreSite(result_2.data);
        }

        // Fetch repair shop data
        const response_3 = await fetch(apiPath1 + "InvSumQtyByStore/repair", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result_3 = await response_3.json();
        if (result_3.status !== true) {
          setRepairShopPresent(false);
          setInvSumByStoreRepair(result_3.msg);
        } else {
          setInvSumByStoreRepair(result_3.data);
        }

        // Set loading to false after all data is fetched
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <div className="cont__dashboard-InvSumStore px16">
        <div className="container-sticky">
          <h5 className="mt8">Inventory (Quantity) Distribution Summary</h5>

          {/* Legenda */}
          <div className="cont__dashboard-InvSumStore-legend">
            <div className="legend-color-ht"></div>
            <span className="sm medium ml4">Heavy Tools</span>
            <div className="legend-color-ht-damaged ml16"></div>
            <span className="sm medium ml4">Heavy Tools [Damaged]</span>
            <div className="legend-color-tool ml16"></div>
            <span className="sm medium ml4">Tools</span>
            <div className="legend-color-consumable ml16"></div>
            <span className="sm medium ml4">Consumable</span>
          </div>
          <hr />
        </div>

        {/* Warehouse Data Table */}
        <p className="bold txt-darkblue my8">Warehouse</p>

        {
          warehousePresent
            ?
            <>
              <table className="mb16">
                <tbody className="">
                  {
                    invSumByStoreWarehouse.map((item, index) => (
                      <tr key={index} className="dashboard_tr">
                        <td className='small medium' style={{ width: "50%" }}>{item.store_name}</td>
                        <td className="color-ht-dark right" style={{ width: "10%" }}>{item.heavy_tool_qty_ok}</td>
                        <td className="color-ht-damaged right" style={{ width: "10%" }}>{item.heavy_tool_qty_damaged}</td>
                        <td className="color-tool-dark right" style={{ width: "15%" }}>{item.tool_qty}</td>
                        <td className="color-consumable-dark right" style={{ width: "15%" }}>{item.consumable_qty}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </>
            :
            <p className="sm color-ht-dark">No warehouse is linked to logged-in user.</p>
        }

        {/* Site Data Table */}
        <p className="bold txt-darkblue my8">Sites</p>
        {
          sitePresent
            ?
            <>
              <table className="mb16">
                <tbody className="">
                  {
                    invSumByStoreSite.map((item, index) => (
                      <tr key={index} className="dashboard_tr">
                        <td className='small medium' style={{ width: "50%" }}>{item.store_name}</td>
                        <td className="color-ht-dark right" style={{ width: "10%" }}>{item.heavy_tool_qty_ok}</td>
                        <td className="color-ht-damaged right" style={{ width: "10%" }}>{item.heavy_tool_qty_damaged}</td>
                        <td className="color-tool-dark right" style={{ width: "15%" }}>{item.tool_qty}</td>
                        <td className="color-consumable-dark right" style={{ width: "15%" }}>{item.consumable_qty}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </>
            :
            <p className="sm color-ht-dark">No site is linked to logged-in user.</p>
        }

        {/* Repair shop Data Table */}
        <p className="bold txt-darkblue my8">Repair Shop</p>
        {
          repairShopPresent
            ?
            <>
              <table className="">
                <tbody className="">
                  {
                    invSumByStoreRepair.map((item, index) => (
                      <tr key={index} className="dashboard_tr">
                        <td className='small medium' style={{ width: "50%" }}>{item.store_name}</td>
                        <td className="color-ht-dark right" style={{ width: "10%" }}>{item.heavy_tool_qty_repair}</td>
                        <td className="color-ht-dark right" style={{ width: "10%" }}>-</td>
                        <td className="color-tool-dark right" style={{ width: "15%" }}>{item.tool_qty}</td>
                        <td className="color-consumable-dark right" style={{ width: "15%" }}>{item.consumable_qty}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </>
            :
            <p className="sm color-ht-dark">No repair shop is linked to logged-in user.</p>
        }
      </div>
    </>
  );
}